import * as React from "react";

import {
  select,
  Colorable,
  FontSizeable,
  Fontable,
  Weightable,
  LineHeightable
} from "@hubper/theme";
import styled, { css } from "styled-components";

export type TextUppercase = {
  uppercase?: boolean;
};

export type TextProps = Colorable &
  FontSizeable &
  Fontable &
  Weightable &
  LineHeightable &
  TextUppercase & { children?: React.ReactNode } & React.HTMLAttributes<
    HTMLDivElement
  >;

const uppercaseStyle = css<TextUppercase>`
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

const Base = styled.div<TextProps>`
  display: inline-block;
  color: ${select.findColor};
  font-family: ${select.findFont};
  font-weight: ${select.findFontWeight};
  font-size: ${select.findFontSize};
  line-height: ${select.findLineHeight};
  ${p => p.uppercase && uppercaseStyle}
`;

Base.defaultProps = {
  f: "Lato",
  fw: "inherit",
  fs: 0,
  c: ["grey", 9],
  lh: "normal"
};

// Base.displayName = "Text";

export default Base;
